@use '../../../../app/styles/common/breakpoints';
@use '../../../../app/styles/common/mixins';

.offerTop {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: var(--spasing16);

  padding: var(--spasing16) 0;

  &.variant-actionsOnly {
    padding: 0;

    .topLeftSlot,
    .topCenterSlot {
      display: none;
    }
  }

  &.variant-compact {
    .topLeftSlot .offerImageWrapper {
      display: none;
    }

    // display, not visibility: the hidden price/title reserved ~40px of row
    // height (BP-8082). The center slot itself stays in the DOM as the flex
    // spacer between the back arrow and the action icons.
    .topCenterSlot .info {
      display: none;
    }

    // Collapse the row to its 24px icons — the xs iconOnly Button box is 32px
    // otherwise. Padding grows the tap target to 44px (WCAG 2.5.5) while the
    // negative margin cancels it from layout, so the row still reads as 24px.
    .topLeftSlot .backButton {
      width: 44px;
      height: 44px;
      min-width: 44px;
      padding: 10px;
      margin: -10px;
    }
  }

  &.expired {
    .topCenterSlot .info .title,
    .topLeftSlot .offerImageWrapper {
      opacity: 0.5;
    }

    // Phones wrap the message to a second line instead of cutting it (BP-7919)
    .topCenterSlot .info .title {
      @media (max-width: (breakpoints.$tablet - 1px)) {
        @include mixins.line-clamp(2);
      }
    }

    .topCenterSlot .info .description,
    .topRightSlot {
      display: none;
    }
  }

  .topLeftSlot {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    gap: var(--spasing16);
    flex: 0 0 auto;

    max-height: 50px;

    .backButton {
      padding: 0;

      // The Button atom clamps the icon to its 16px xs slot (`.iconSlot svg`);
      // the offer header arrow is 24px per design, same as the heart/share icons.
      svg {
        width: 24px;
        height: 24px;
      }

      // 44px tap target on phones (BP-7919); the margin keeps the 32px footprint, so nothing moves
      @media (max-width: (breakpoints.$tablet - 1px)) {
        width: 44px;
        height: 44px;
        min-width: 44px;
        padding: 10px;
        margin: -6px;
      }
    }

    .offerImageWrapper {
      width: 56px;
      height: 56px;
      overflow: hidden;
      border-radius: var(--btn-small-general-corner-radius);
    }
  }

  .topCenterSlot {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: center;
    flex: 1 1 auto;
    min-width: 0;

    .info {
      overflow: hidden;
      width: 100%;
      display: flex;
      flex-flow: column nowrap;
      gap: var(--spasing04);

      color: var(--fg-primary);

      .title {
        text-overflow: ellipsis;

        @include mixins.heading-secondary-200;
        @include mixins.line-clamp(1);

        @include mixins.tablet {
          @include mixins.heading-primary-300;
        }
      }

      .description {
        text-overflow: ellipsis;

        @include mixins.caption-primary-400;
        @include mixins.line-clamp(1);

        @include mixins.tablet {
          @include mixins.caption-primary-450;
        }
      }
    }
  }

  .topRightSlot {
    margin-left: calc(var(--spasing40) - var(--spasing16));
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    gap: var(--spasing20);
    flex: 0 0 auto;

    .contacts {
      margin-right: var(--spasing04);
    }

    .contactButton {
      padding: var(--spasing16) var(--spasing24);
    }

    .favoriteGroup {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      gap: var(--spasing08);
    }

    .favoriteCounter {
      color: var(--fg-secondary);

      @include mixins.heading-secondary-100;
    }

    .shareButton {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      background: transparent;
      border: none;
      color: var(--fg-primary);
      cursor: pointer;
      line-height: 0;

      &:focus {
        outline: none;
      }

      &:focus-visible {
        outline: 2px solid var(--shadow-focus);
        outline-offset: 2px;
        border-radius: 4px;
      }

      svg {
        width: 24px;
        height: 24px;
      }
    }
  }
}
